import React from 'react'
import Menu from 'antd/lib/menu'
import Dropdown from 'antd/lib/dropdown'

const handleView = (e, onViewChange, val) => {
  e.preventDefault()
  onViewChange(val)
}

const menu = (strings, onViewChange) => {
  return (
    <Menu>
      <Menu.Item key="0">
        <a onClick={e => handleView(e, onViewChange, 'grid_view')}>{strings.grid_view}</a>
      </Menu.Item>
      <Menu.Item key="1">
        <a onClick={e => handleView(e, onViewChange, 'map_view')}>{strings.map_view}</a>
      </Menu.Item>
      <Menu.Item key="2">
        <a onClick={e => handleView(e, onViewChange, 'list_view')}>{strings.list_view}</a>
      </Menu.Item>
    </Menu>
  )
}

const View = (props) => {
  return (
    <div className="gw-search__view-control">
      <Dropdown overlay={menu(props.strings, props.onViewChange)} trigger={['click']}>
        <div className="gw-search__view-control-trigger">
          {props.strings[props.view]}
        </div>
      </Dropdown>
    </div>
  )
}

export default View


// WEBPACK FOOTER //
// ./src/components/search/View.js